// extracted by mini-css-extract-plugin
export var chevron = "_as-2";
export var dropdownItems = "_as-0";
export var item = "_as-1";